module.exports = __webpack_public_path__ + "static/media/icon-arrow-left.73b86f8d.svg";